/* eslint-disable @typescript-eslint/no-unused-vars */

import { EnrollmentOption } from "types/landlord/enrollment";
import { AlgoliaUser } from "views/renters/types";

export const prepareAlgoliaData = (
  data: AlgoliaUser[],
  enrollmentOption: EnrollmentOption
) => {
  return data.map((renter) => {
    const { units, manager, phone, email, ...property } = renter.property;
    const { boomCustomerId, pets, hasPets, ...customer } = renter.customer;
    const {
      _highlightResult,
      boomEnrollmentStatus,
      property: _property,
      customer: _customer,
      ...renterDetails
    } = renter;

    const ret = {
      ...renterDetails,
      property,
      customer: customer,
      opt_out: enrollmentOption.optOut,
      opt_in: enrollmentOption.optIn
    };

    return ret;
  });
};
